import React from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdEdit } from "react-icons/md";

const ViewDetails = ({ setViewDetail, SelectedData, setEditBasicAsset, setEditAssignmentDetails, setEditMaintenanceDetails, setEditPurchaseDetails }) => {
  const onClose = () => {
    setViewDetail(false);
  };
  const onEditBasicAsset = () => {
    setEditBasicAsset(true);
    setViewDetail(false);

  };
  const onEditAssignmentDetails = () => {
    setEditAssignmentDetails(true);
    setViewDetail(false);
  };
  const onEditPurchaseDetails = () => {
    setEditPurchaseDetails(true);
    setViewDetail(false);
  };
  const getStatusBadge = (status) => {
    const statusStyles = {
      "In Use": "bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-18 h-7 flex items-center justify-center rounded-full",
      "Maintenance": "bg-yellow-100 text-yellow-800",
      "Disposed": "bg-rose-100 text-rose-700 text-xs border-rose-300 border w-18 h-7 flex items-center justify-center rounded-full",
      "Not Assigned": "bg-gray-100 text-gray-800",
    };

    return (
      <span className={`px-4 py-2 rounded-full text-xs font-semibold ${statusStyles[status] || "bg-gray-100 text-gray-800"}`}>
        {status || "Disposed"}
      </span>
    );
  };

  return (
    <Container>
      <div className="flex items-center justify-between bg-[#0078BD] py-4 px-4">
        <Title className="text-white">{"All Details"}</Title>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </div>
      <div className="flex items-center gap-3 bg-gray-100 p-4 justify-between">
        <div className="flex flex-col">
          <span className="font-medium"><Value>{SelectedData?.name || "Furniture and Fixture"}</Value>
          </span>
          <span className="text-sm text-gray-600">{SelectedData?.email || "Dining Table"}</span>
        </div>
        <div className="flex flex-col">
          {/* <span>{SelectedData?.currentStatus || "In Use"}</span> */}
          <div>{getStatusBadge(SelectedData?.currentStatus || "In Use")}</div>

        </div>
      </div>
      <div className="px-4 h-full flex flex-col justify-between py-3 relative">
        <Wrapper>
          <BtnWrapper>
            <SectionTitle>
              Asset Basic Details
            </SectionTitle>
          </BtnWrapper>
          <Section>

            <Row>
              <Label>Total Units</Label>
              <Value>{SelectedData?.mobile || "20"}</Value>
            </Row>
            <Row>
              <Label>Description</Label>
              <Value>{SelectedData?.mobile || "Extended Warranty"}</Value>
            </Row>

          </Section>
          <BtnWrapper>
            <SectionTitle>

            </SectionTitle>
            <SubmitBtn type="submit" onClick={onEditBasicAsset}>
              Edit
            </SubmitBtn>
          </BtnWrapper>

          <BtnWrapper>
            <SectionTitle>
              Asset Purchase Details
            </SectionTitle>
          </BtnWrapper>
          <Section>
            <Row>
              <Label>Purchase Date</Label>
              <Value>{SelectedData?.purchaseDate || "25-05-2024"}</Value>
            </Row>
            <Row>
              <Label>Purchase Price</Label>
              <Value>{SelectedData?.purchasePrice || "25000"}</Value>
            </Row>
            <Row>
              <Label>Depreciation</Label>
              <Value>{SelectedData?.depreciation || "4%"}</Value>
            </Row>
            <Row>
              <Label>Vendor Name</Label>
              <Value>{SelectedData?.vendorName || "Vendor 2"}</Value>
            </Row>
          </Section>
          <BtnWrapper>
            <SectionTitle>
              
            </SectionTitle>
            <SubmitBtn type="submit" onClick={onEditPurchaseDetails}>
              Edit
            </SubmitBtn>
          </BtnWrapper>

          <BtnWrapper>
            <SectionTitle>
              Asset Assigned Details
            </SectionTitle>
          </BtnWrapper>
          <Section>
            <Row>
              <Label>Property Assigned</Label>
              <Value>{SelectedData?.assignedProperty || "SuperTech"}</Value>
            </Row>
            <Row>
              <Label>Assigned To</Label>
              <Value>{SelectedData?.assignTo || "Tenant"}</Value>
            </Row>
          </Section>
          <BtnWrapper>
            <SectionTitle>
             
            </SectionTitle>
            <SubmitBtn type="submit" onClick={onEditAssignmentDetails}>
              Edit
            </SubmitBtn>
          </BtnWrapper>
        </Wrapper>
      </div>
    </Container>
  );
};

const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const Section = tw.div`relative`;
const SectionTitle = tw.h2`text-md font-semibold text-gray-700 flex justify-between items-center`;
const Row = tw.div`flex justify-between py-1 md:p-1`;
const Label = tw.label`text-sm text-gray-500 font-normal`;
const Value = tw.span`text-gray-800 font-medium`;
const SubmitBtn = tw.button`
  flex text-md w-auto md:text-sm text-blue-600 mt-auto hover:text-blue-600 underline
`;
const BtnWrapper = tw.div`w-full flex items-center justify-between `;
export default ViewDetails;